import { Carousel_shape } from '../../components/Carousel_shape/Carousel_shape'
import './Shape.css'

export const Shape = () => {
  return (
    <div className='ShapeContainer'>
      <Carousel_shape />
    </div>
  )
}
